import { getStore } from '../store/store';

export default function getCopilotThemeTimestamp(): string {
    return getStore().timestamp;
}
